<template>
  <div :class="$style['pt-hospital-form']">
    <pt-page-title :title="isEdit?'编辑医院':'新建医院'"></pt-page-title>
    <pt-sub-title title="医院信息"></pt-sub-title>
    <table :class="$style['role-customer-basic-message']">
      <pt-form-list-item label="医院名称：" required>
        <wt-input v-model="formValue.name" v-validate="'required'" data-vv-as="医院名称" placeholder="请输入医院名称"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="分/子公司：" required>
        <wt-selector data-vv-as="分/子公司" v-validate="'required'" :class="$style['org-select']" :options="company"
          v-model="formValue.branchId"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="地区：" required>
        <wt-input v-model="formValue.address" v-validate="'required'" data-vv-as="地区" placeholder="请输入地区"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="医院地址：">
        <wt-input v-model="formValue.hospitalAddress" placeholder="请输入医院地址">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="联系人：">
        <wt-input v-model="formValue.contractor" placeholder="请输入联系人">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="手机号：">
        <wt-input v-model="formValue.mobile" placeholder="请输入手机号" type="number"></wt-input>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-hospital-form'

export default {
  name: 'pt-hospital-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    company: {
      type: Array,
      default: function () {
        return []
      }
    },
    hospitalDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    hospitalDetail: {
      handler: function (val) {
        this.formValue = val
      }
    }
  },
  data () {
    return {
      formValue: {
        address: null
      }
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .menu-permissions {
    // margin-bottom: 20px;
    line-height: 40px;
  }

  .pt-hospital-form {
    table {
      padding: 0 20px;
    }
  }

  .role-customer-basic-message {
    max-width: 500px
  }

  .org-select {
    width: 100%
  }

  .edit-password-text {
    color: red;
    font-size: 12px
  }

</style>
